/*!
 * llc-hide-search.js
 * Hides the hidden Virginia LLC Formation service product from on-site search
 * (full search results page AND the predictive-search dropdown).
 * Theme-agnostic: matches by product handle in result links, then hides the
 * closest product-card container. Also watches for AJAX-loaded results.
 */
(function () {
  "use strict";

  var HIDDEN_HANDLES = ["virginia-llc-formation-service-for-non-u-s-u-s-residents"];

  function linkMatches(href) {
    if (!href) return false;
    href = href.toLowerCase();
    for (var i = 0; i < HIDDEN_HANDLES.length; i++) {
      if (href.indexOf("/products/" + HIDDEN_HANDLES[i]) !== -1) return true;
    }
    return false;
  }

  var CARD_SELECTOR =
    "li, .grid__item, .card-wrapper, .card, .product-card, .product-item, " +
    ".product-grid-item, .predictive-search__list-item, [class*='product-card'], " +
    "[class*='card-wrapper'], [class*='search-result']";

  function hideWithin(root) {
    if (!root || !root.querySelectorAll) return;
    var links = root.querySelectorAll('a[href*="/products/"]');
    for (var i = 0; i < links.length; i++) {
      if (linkMatches(links[i].getAttribute("href"))) {
        var card = links[i].closest(CARD_SELECTOR) || links[i];
        card.style.setProperty("display", "none", "important");
        card.setAttribute("data-llc-hidden", "1");
      }
    }
  }

  function run() {
    if (location.pathname.toLowerCase().indexOf("/search") !== -1) {
      hideWithin(document);
    }
    var pviews = document.querySelectorAll(
      "predictive-search, #predictive-search, .predictive-search, " +
      "[data-predictive-search], [id*='predictive'], [class*='predictive']"
    );
    for (var i = 0; i < pviews.length; i++) hideWithin(pviews[i]);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", run);
  } else {
    run();
  }

  try {
    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].addedNodes && mutations[i].addedNodes.length) {
          run();
          return;
        }
      }
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
  } catch (e) {}
})();
